import { t } from 'i18next';
import {
  STAGE_TYPE_IDS,
  STAGE_TYPES,
} from '../../../../../constants/workflow.constant';
import { checkRequired, removeUndefined } from './validationUtils';

const validate = async ({
  name,
  form_id,
  form_ids,
  stage_type_id,
  target_category_id,
  approver_role_id,
  payment_enabled,
  payment_amount,
  stageTypesSelection,
  existingNames,
}) => {
  let errors = {};

  errors = removeUndefined({
    name: checkRequired(name),
    stage_type_id: checkRequired(stage_type_id),
  });

  if (name && existingNames?.includes(name.trim())) {
    errors.name = t('stageConfig.nameAlreadyExists');
  }

  const isAssessmentReview = stageTypesSelection?.find(
    (stageType) =>
      stageType.type === STAGE_TYPES.ASSESSMENT_REVIEW &&
      stageType.id === stage_type_id
  );

  // Both Submission and Review stages use form_ids array
  if (
    stage_type_id === STAGE_TYPE_IDS.REVIEW ||
    stage_type_id === STAGE_TYPE_IDS.SUBMISSION ||
    isAssessmentReview
  ) {
    if (!form_ids || form_ids.length === 0) {
      errors.form_ids = t('stageConfig.atLeastOneFormRequired');
    }
  }

  // Conditional validation for target_category_id
  if (stage_type_id === STAGE_TYPE_IDS.SUBMISSION && !target_category_id) {
    errors = {
      ...errors,
      target_category_id: checkRequired(target_category_id),
    };
  }

  // Conditional validation for approver_role_id
  if (
    (stage_type_id === STAGE_TYPE_IDS.REVIEW || isAssessmentReview) &&
    !approver_role_id
  ) {
    errors = {
      ...errors,
      approver_role_id: checkRequired(approver_role_id),
    };
  }

  if (stage_type_id === STAGE_TYPE_IDS.SUBMISSION && payment_enabled) {
    const amountValue = payment_amount;
    const numericAmount = Number(amountValue);
    const hasValue =
      amountValue !== undefined && amountValue !== null && amountValue !== '';
    const amountString = hasValue ? String(amountValue) : '';
    const hasValidPrecision = /^\d+(\.\d{1,2})?$/.test(amountString);

    if (
      !hasValue ||
      Number.isNaN(numericAmount) ||
      numericAmount < 0 ||
      !hasValidPrecision
    ) {
      errors.payment_amount = t('stageConfig.paymentAmountInvalid');
    }
  }

  return errors;
};

export default validate;
